import React from 'react';

import Container from './Container';
import Field from "./Field";

export default ({ mseller }) => (
  <Container>
    <Field>{mseller.login}</Field>
    <Field>{mseller.mseller_url}</Field>
    <Field>{mseller.location}</Field>
    <Field>{mseller.date}</Field>
    <Field>{mseller.activated}</Field>
  </Container>
);
